import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useForm } from "react-hook-form"
import shopCore from "../../core/shop.core"
import { SalesLocation } from "../../types/shop"
import { useRouter } from "next/router"

export default function useAddSalesLocation() {
  const { push } = useRouter()
  const queryClient = useQueryClient()
  const methods = useForm<SalesLocation>()

  const formhandler = useMutation({
    mutationFn: async (data: SalesLocation) => {
      return await shopCore.addSalesLocation(data)
    }, onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sales-location"] })
      push("/shop/location")
    }
  })

  const onSubmit = async (data: SalesLocation) => {
    await formhandler.mutateAsync(data)
  }

  return {
    methods,
    onSubmit,
    formhandler,
  }
}
